import { List, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";
import InstrumentSubTypeLookup from "./InstrumentSubTypeLookup";

@NeoModel
export default class InstrumentTypeLookup extends ModelBase {

    public staticInstrumentTypeID: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public instrumentTypeName: string = "";

    public instrumentSubTypeList = new List(InstrumentSubTypeLookup);

    public isExpanded: boolean | null = null;
}